<template>
  <div>
    <groups-list
      :items="items"
      :count="count"
      :search="search"
      :show-load-more="true"
      mode="loadMore"
      scrollable
      @tabChanged="onTabChange"
      @cellClicked="onCellClicked"
      @onSearch="onSearch"
      @pageChange="onPageChange"
      @reached-bottom="onBottomReached"
      @delete="onDelete"
      @createGroup="onOpenCreateGroup"
    >
      <template v-slot:breadcrumb>
        <base-breadcrumb
          :routes="routes"
          class="my-0 pb-1"
        />
      </template>
      <template v-slot:title>
        {{ profile.user.first_name }} {{ profile.user.last_name }} Group's
      </template>
    </groups-list>
    <GroupCreate
      ref="create"
      :show-create="showCreate"
      :loading="loading"
      @create="onCreateGroup"
    />
  </div>
</template>

<script>

import _ from 'lodash';
import GroupsList from '@/components/Widgets/GroupsList';

export default {

  name: 'ManageGroupsContainer',
  components: {
    GroupsList,
  },
  data() {
    return {
      search: '',
      page: 1,
      pageSize: 30,
      nextPageExists: true,
      showCreate: false,
    };
  },
  computed: {
    groups() {
      if (!this.$store.state.groups) {
        return {};
      }
      return this.$store.state.groups;
    },
    items() {
      if (!this.groups) {
        return [];
      }
      return this.groups.groups;
    },
    count() {
      if (!this.groups) {
        return 0;
      }
      return this.groups.count;
    },
    profile() {
      if (!this.$store.state.profiles.item) {
        return {
          user: {
            first_name: '',
            last_name: '',
          },
        };
      }
      return this.$store.state.profiles.item;
    },
    loading() {
      return this.$store.state.groups.isLoading;
    },
    profileLoading() {
      return this.$store.state.profiles.itemStatsLoading;
    },
    routes() {
      return [
        {
          name: 'Dashboard',
          link: '/dashboard',
        },
        {
          name: `${this.profile.user.first_name} ${this.profile.user.last_name}`,
          link: `/user/${this.profile.pk}`,
          loading: this.profileLoading,
        },
        {
          name: 'Manage Clients',
        },
      ];
    },
  },
  watch: {
    search(newval) {
      this.$store.dispatch('groups/reset');
      if (this.page !== 1) {
        this.page = 1;
      } else {
        this.fetchData();
      }
    },
    page() {
      this.fetchData();
    },
  },
  mounted() {
    this.$store.dispatch('groups/reset');
    this.fetchData();
    this.$store.dispatch('profiles/fetchItem', this.$route.params.id);
  },
  methods: {
    onOpenCreateGroup() {
      this.$refs.create.open();
      this.showCreate = true;
    },
    onBottomReached() {
      if (this.nextPageExists && !this.loading) {
        this.page += 1;
      }
    },
    onTabChange(evt) {
      if (evt === 1) {
        this.$router.push('manage-groups');
      } else {
        this.$router.push('manage-clients');
      }
    },
    onCellClicked(evt) {
      this.$router.push(`/user/${this.profile.pk}/group/${evt.pk}`);
    },
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    onPageChange(page) {
      this.truePage = page;
      window.scroll({ top: 0, left: 0 });
    },
    fetchData() {
      if (this.loading) {
        console.log('Already loading!');
        return;
      }
      const kwargs = {
        search: this.search,
        page: this.page,
        page_size: this.pageSize,
      };
      const { id } = this.$route.params;
      this.$store.dispatch('groups/fetchStylistGroups', { id, kwargs }).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next !== null;
        }
      });
    },
    onCreateGroup(evt) {
      const params = {
        ...evt,
        profile: this.$route.params.id,
      };
      this.$store.dispatch('groups/addSingleGroup', params).then((response) => {
        this.$router.push(`/user/${this.profile.pk}/group/${response.data.pk}`);
        this.showCreate = false;
      });
    },
    onDelete(group) {
      this.$store.dispatch('groups/deleteGroup', group.pk);
    },
  },
};
</script>

<style lang="css" scoped>
</style>
